"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubReactionChuteBrusqueValeurInvestissementCorporationTrads = void 0;
exports.ESubReactionChuteBrusqueValeurInvestissementCorporationTrads = {
    conserver: "Vous les conservez dans une politique de long terme",
    investir: "Vous en profitez pour investir",
    vendre: "Vous les vendez afin de limiter vos pertes",
};
